module.exports = __webpack_public_path__ + "img/icon_metaverse.ac1bb5a.svg";